<h3>
  Flexibler Zuschlag
  @if (('workflow.price.increase.flex'|HasPerm)) {
    <button class="btn btn-link"
      title="Flexiblen Zuschlag bearbeiten"
      (click)="openUpdateModal()">
      <i class="fa fa-pencil"></i>
    </button>
  }
  @if (('workflow.price.increase.flex'|HasPerm)) {
    <button class="btn btn-link"
      title="Flexiblen Zuschlag entfernen"
      (click)="delete()">
      <i class="fa fa-minus red-font"></i>
    </button>
  }
</h3>

<div class="whitebox ordersituation whitebox-margin">
  <div>Zuschlag: {{flexPriceIncrease.increase|money:2}}&nbsp;%</div>
  <div>Quelle:
    @switch (flexPriceIncrease.source) {
      @case (1) {
        Vorgang
      }
      @case (2) {
        Import
      }
    }
  </div>
</div>
